// The Clerk instance is allowlist-only: `not_allowed_access` is the expected
// answer for an email nobody invited, not a fault. Clerk's own copy for it
// ("<email> is not allowed to access this application") reads like a system
// error, so we substitute our own. Matched on the code — the SDK's message
// text is not a contract.
const clerkErrorCode = (err: unknown): string | undefined => {
  if (typeof err !== 'object' || err === null || !('errors' in err)) return;
  const { errors } = err as { errors?: unknown };
  if (!Array.isArray(errors)) return;
  const code = (errors.at(0) as { code?: unknown } | undefined)?.code;
  return typeof code === 'string' ? code : undefined;
};

export const toSignUpErrorMessage = (
  err: unknown,
  email: string | null | undefined,
  fallback: string
): string => {
  if (clerkErrorCode(err) === 'not_allowed_access') {
    // The ticket-strategy branch never collects an address, so `email` can be
    // empty — which used to render as a bare " is only allowed to register…".
    const subject = email?.trim() || 'This email address';
    return `${subject} is only allowed to register if invited by an Administrator.`;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
};
